function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.02879 5.39678L5.42181 2L7.59983 4.1806L9.72873 2.04935L11.9535 4.27654L14.1782 2.04935L16.3681 4.24151L18.607 2L22 5.39678L19.7587 7.64053L21.9133 9.79749L19.6855 12.0278L21.9133 14.2581L19.7897 16.384L22 18.5967L18.607 21.9934L16.399 19.783L14.1846 22L11.9598 19.7728L9.73511 22L7.57501 19.8377L5.42181 21.9934L2.02879 18.5967L4.1844 16.4387L2 14.2519L4.22783 12.0216L2 9.79127L4.20905 7.57962L2.02861 5.39678H2.02879Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 7,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 1,
  fill: "#0067E2"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 15,
  r: 1,
  fill: "#0067E2"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 1,
  fill: "#0067E2"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 19,
  r: 1,
  fill: "#0067E2"
});

var SvgMaterialLibrary = function SvgMaterialLibrary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMaterialLibrary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/materialLibrary.2abb048e.svg";
export { ForwardRef as ReactComponent };